import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import { computed, defineComponent, toRefs, ref, getCurrentInstance } from "@vue/composition-api";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { isEmpty } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { useDocumentsStoreActions } from "@Broker/@Modules/clients/applications/documents/store/document-helpers";
import * as DocumentsActions from "@Broker/@Modules/clients/applications/documents/store/documents-actions";
import * as SubmissionActions from "@Broker/@Modules/clients/applications/application/store/lender-submit-actions";
import { useApplicationStoreActions } from "@Broker/@Modules/clients/applications/application/store/application-helpers";
import { showToast } from "@Shared/@Utils/constants";
import { formatDateHour } from "@Shared/@Utils/helpers/dates";
export default defineComponent({
  name: "DocumentsToSendModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    documentsToSend: {
      type: Array,
      required: true
    },
    lenderName: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    submission: {
      type: Object,
      default: () => ({}),
      required: true
    },
    documentListEmpty: {
      type: Boolean,
      required: true
    }
  },
  setup(props) {
    const {
      t
    } = useI18n();
    const lenderDocSubmissionDisclaimerAccepted = ref(false);
    const internalInstance = getCurrentInstance();
    const {
      documentsToSend,
      lenderName,
      applicationId,
      clientUsername,
      submission
    } = toRefs(props);
    const selectedDocsToSend = ref([]);
    const sendingDocuments = ref(false);
    const isEmptyData = computed(() => isEmpty(documentsToSend.value));
    const {
      SEND_NEW_DOCUMENTS
    } = useDocumentsStoreActions([DocumentsActions.SEND_NEW_DOCUMENTS]);
    const {
      LOAD_SUBMISSION_HISTORY
    } = useApplicationStoreActions([SubmissionActions.LOAD_SUBMISSION_HISTORY]);
    const table = computed(() => ({
      columns: ["selected", "classificationType", "fileName"],
      options: {
        filterable: false,
        sortable: [],
        headings: {
          classificationType: t("global.words.classification"),
          fileName: t("documents.documentName")
        },
        perPage: 999999,
        tabbable: false,
        skin: "table mb-0",
        columnsClasses: {
          selected: "w-10 text-center",
          classificationType: "w-30",
          fileName: "w-40"
        },
        texts: {
          noResults: t("request-package.requestDocuments.emptyDocumentsClassification.full")
        }
      }
    }));
    const canSend = computed(() => {
      const hasDocumentsSelected = selectedDocsToSend.value.length > 0;
      const isDisclaimerAccepted = lenderDocSubmissionDisclaimerAccepted.value;
      if (hasDocumentsSelected) {
        return isDisclaimerAccepted;
      }
      return !isEmpty(selectedDocsToSend.value);
    });
    const documentIsSelected = computed(() => {
      return documentId => {
        var _context;
        return _includesInstanceProperty(_context = selectedDocsToSend.value).call(_context, documentId);
      };
    });
    const handleSelectDocument = documentId => {
      var _context2;
      const alreadySelected = _includesInstanceProperty(_context2 = selectedDocsToSend.value).call(_context2, documentId);
      if (alreadySelected) {
        var _context3;
        selectedDocsToSend.value = _filterInstanceProperty(_context3 = selectedDocsToSend.value).call(_context3, d => d !== documentId);
      } else {
        selectedDocsToSend.value.push(documentId);
      }
    };
    const handleSelectAll = () => {
      if (selectedDocsToSend.value.length === documentsToSend.value.length) {
        selectedDocsToSend.value = [];
      } else {
        var _context4;
        selectedDocsToSend.value = [];
        _mapInstanceProperty(_context4 = documentsToSend.value).call(_context4, doc => selectedDocsToSend.value.push(doc["documentId"]));
      }
    };
    const handleSendDocuments = async () => {
      sendingDocuments.value = true;
      await SEND_NEW_DOCUMENTS({
        applicationId: applicationId.value,
        clientUsername: clientUsername.value,
        lenderName: lenderName.value,
        docsToLender: selectedDocsToSend.value
      });
      await LOAD_SUBMISSION_HISTORY({
        clientUsername: clientUsername.value,
        applicationId: applicationId.value
      });
      sendingDocuments.value = false;
      selectedDocsToSend.value = [];
      (internalInstance == null ? void 0 : internalInstance.proxy).$hideModal();
      if (submission.value.docMethod && submission.value.docMethod.toUpperCase() === "E") {
        showToast("success", t("notification-messages.successAddDocumentsToLenderElectronic", {
          lenderName: lenderName.value
        }).toString());
      } else {
        showToast("success", t("notification-messages.successAddDocumentsToLender", {
          lenderName: lenderName.value
        }).toString());
      }
    };
    const showHistoryTable = ref(false);
    const documentsSentWithDetails = computed(() => {
      var _context5, _context6, _submission$value$doc;
      return _sortInstanceProperty(_context5 = _sliceInstanceProperty(_context6 = (_submission$value$doc = submission.value.documentsSentWithDetails) != null ? _submission$value$doc : []).call(_context6)).call(_context5, (documentA, documentB) => {
        const dateA = new Date(documentA.documentSentDate || documentA.insertionTimestamp).getTime();
        const dateB = new Date(documentB.documentSentDate || documentB.insertionTimestamp).getTime();
        return dateB - dateA;
      });
    });
    const historyTable = computed(() => ({
      columns: ["classification", "fileName", "insertionTimestamp"],
      options: {
        filterable: false,
        sortable: [],
        headings: {
          classification: t("global.words.classification"),
          fileName: t("documents.documentName"),
          insertionTimestamp: t("documents.submissionDate")
        },
        perPage: 999999,
        skin: "table table-hover",
        columnsClasses: {
          classification: "w-10",
          fileName: "w-20",
          insertionTimestamp: "w-10"
        },
        texts: {
          noResults: t("documents.emptyDocumentsSentHistory")
        }
      }
    }));
    const closeModal = close => {
      selectedDocsToSend.value = [];
      close();
    };
    return {
      isEmptyData,
      table,
      canSend,
      sendingDocuments,
      selectedDocsToSend,
      documentIsSelected,
      handleSelectDocument,
      handleSelectAll,
      handleSendDocuments,
      showHistoryTable,
      historyTable,
      documentsSentWithDetails,
      formatDateHour,
      closeModal,
      lenderDocSubmissionDisclaimerAccepted
    };
  }
});